


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { BranchObj, BranchItem } from '@/types/tenant/calcGroup'
import { Tree } from 'element-ui'

@Component({
  name: 'moduleItem'
})
export default class extends Vue {
  @Prop({ required: true, default: () => { return { branch: [] } } }) dataObj!: BranchObj
  @Prop({ required: true }) type!: string

  defaultProps = {
    children: 'subBranch',
    label: 'name'
  }

  checkKeys: string[] = []

  dataCheckChange (itemData: BranchItem, checked: boolean) {
    const filterData = (dataObj: BranchObj | BranchItem) => {
      const itemArr = (dataObj as BranchObj).branch || (dataObj as BranchItem).subBranch
      itemArr && itemArr.forEach(item => {
        if (item.id === itemData.id) {
          if (checked) {
            item.selected = true
            itemArr.forEach((itemUnb) => {
              if (itemUnb.id !== itemData.id) {
                itemUnb.selected = false
              }
            })
          } else {
            item.selected = false
          }
        }
        filterData(item)
      })
    }
    if (this.type === 'computeModelTree') {
      filterData(this.dataObj)
    } else {
      itemData.selected = !itemData.selected
    }
    this.$emit('computedTreeChange', this.dataObj, this.type)
  }

  filterChecked () {
    const checkedArr: string[] = []
    const filterData = (dataObj: BranchObj | BranchItem) => {
      const itemObj = (dataObj as BranchObj).branch || (dataObj as BranchItem).subBranch
      itemObj && itemObj.forEach(item => {
        if (!item.id) {
          item.disabled = true
        }
        if (item.selected) {
          checkedArr.push(item.name)
        }
        filterData(item)
      })
    }
    filterData(this.dataObj)
    return checkedArr
  }

  @Watch('dataObj', { immediate: true, deep: true })
  getDataObj (v1: BranchObj) {
    if (v1) {
      this.checkKeys = this.filterChecked()
      if (this.$refs[this.type]) {
        (this.$refs[this.type] as Tree).setCheckedKeys(this.checkKeys)
      }
    }
  }
}
